const Layout = () => import('@/layout/index.vue')

export default {
    path: '/user',
    component: Layout,
    redirect: '/user/index',
    name: 'User',
    meta: {
        title: '裂变用户',
        icon: 'users'
    },
    children: [
        {
            path: 'index',
            name: 'UserIndex',
            component: () => import('@/views/user/index.vue'),
            meta: {
                title: '裂变用户',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/user',
                auth: ['user']
            }
        }
    ]
}
